/**
 * ============================================================================
 * ADMIN ROUTE COMPONENT - Role-Based Route Protection
 * ============================================================================
 * 
 * Protects admin routes - only allows admin and super_admin roles
 */

import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../../providers';
import { ROUTES } from '../../utils/constants';
import Spinner from '../common/Spinner';

/**
 * AdminRoute Component
 * @param {Object} props
 * @param {React.ReactNode} props.children - Child components to render
 * @returns {JSX.Element}
 */
const AdminRoute = ({ children }) => {
  const { user, isAuthenticated, loading } = useAuthContext();
  
  // Show loading while checking auth
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spinner size="lg" />
      </div>
    );
  }
  
  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }
  
  // Check if user has admin role
  const userRole = user?.role || 'user';
  const isAdmin = userRole === 'admin' || userRole === 'super_admin';
  
  // Redirect to dashboard if not admin
  if (!isAdmin) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }
  
  return children;
};

export default AdminRoute;
